export function apiUrl (url: string): string {
  return `${process.env.VUE_APP_API_ENDPOINT}api/wrcp/kadowaki-dental/webappointment/${url}`
}
